import React, { useState, useEffect } from "react";
import "./statusDropdown.css";
import CricleCross from "../../Assets/Icons/circle-x-filled.png";
import { useTranslation } from "react-i18next";

const StatusDropdown = ({ statusTypes, onStatusChange, setShowFilter, selectedStatuses, setSelectedStatuses }) => {
  const [isWide, setIsWide] = useState(false);
  const [action, setAction] = useState(null);
  const { t } = useTranslation();

  const statusLabelMap = {
    ACTIVE: t("active"),
    INACTIVE: t("inactive"),
    OPEN: t("OPEN") || "Open",
    IN_REVIEW: t("inReview"),
    REJECTED: t("REJECTED") || "Rejected",
    QUOTED: t("quoted"),
    PAID: t("PAID"),
    PENDING: t("PENDING"),
    IN_PROGRESS: t("IN_PROGRESS"),
    CANCELLED: t("CANCELLED"),
    COMPLETED: t("COMPLETED"),
    ASSIGNED: t("ASSIGNED") || "Assigned",
    CHECKED_IN: t("CHECKED_IN"),
    VERIFIED: t("VERIFIED") || "Verified",
    CONFIRMED: t("CONFIRMED") || "Confirmed",
    CHECKED_OUT: t("CHECKED_OUT") || "Checked Out",
    SCHEDULED: t("SCHEDULED") || "Scheduled",
  };

  useEffect(() => {
    setIsWide(statusTypes.length > 5);
  }, [statusTypes.length]);

  const [localStatuses, setLocalStatuses] = useState(selectedStatuses || []);

  const handleCheckboxChange = (status) => {
    setLocalStatuses((prev) =>
      prev.includes(status) ? prev.filter((s) => s !== status) : [...prev, status]
    );
  };

  const handleApply = () => {
    setSelectedStatuses(localStatuses.length > 0 ? localStatuses : null);
    onStatusChange(localStatuses.length > 0 ? localStatuses : null);
    setShowFilter(false);
  };

  const handleClearAll = () => {
    setLocalStatuses([]);
    setSelectedStatuses(null);
    onStatusChange(null);
    setShowFilter(false);
  };

  const getGridClass = (count) => {
    if (count <= 1) return "columns-1";
    if (count <= 2) return "columns-2";
    if (count <= 3) return "columns-3";
    if (count <= 4) return "columns-4";
    return "columns-5";
  };

  return (
    <div className={`sd-dropdown ${isWide ? "wide" : ""}`}>
      <div className="sd-header">
        <section className="sd-title">{t("filterByStatus")}</section>
        <section className="sd-close" onClick={() => setShowFilter(false)} aria-label="Close filter">
          <img src={CricleCross} alt="X" />
        </section>
      </div>
      <p className="sd-description">{t("selectCriteriaFilter")}</p>
      <div className={`sd-options ${getGridClass(statusTypes.length)}`}>
        {statusTypes.map((status) => (
          <div key={status} className="sd-option">
            <input
              type="checkbox"
              id={status}
              checked={localStatuses.includes(status)}
              onChange={() => handleCheckboxChange(status)}
              aria-label={`Filter by ${statusLabelMap[status]}`}
            />
            <label htmlFor={status}>{statusLabelMap[status]}</label>
          </div>
        ))}
      </div>
      <div className="sd-actions">
        <section className="sd-action apply-btn" onClick={handleApply} aria-label="Apply filters">
          {t("apply")}
        </section>
        <section className="sd-action" onClick={handleClearAll} aria-label="Clear all statuses">
          {t("clear")}
        </section>
      </div>
    </div>
  );
};

export default StatusDropdown;
